module.exports = __webpack_public_path__ + "media/images/room/hall_v1-c15cba72b735f3b1151901855f406154.png";